const { WOW } = require('wowjs/dist/wow.js');

const scrollToTop = () => {
    if (typeof window === 'undefined') {
        return;
    }

    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
};

const forceScrollToTop = () => {
    scrollToTop();

    window.requestAnimationFrame(() => {
        scrollToTop();
    });

    window.setTimeout(scrollToTop, 0);
    window.setTimeout(scrollToTop, 75);
    window.setTimeout(scrollToTop, 250);
};

exports.onClientEntry = () => {
    if (typeof window === 'undefined' || !window.history || !('scrollRestoration' in window.history)) {
        return;
    }

    window.history.scrollRestoration = 'manual';
};

exports.onRouteUpdate = () => {
    forceScrollToTop();

    if (typeof window.MutationObserver === 'undefined') {
        return;
    }

    const wow = new WOW();
    wow.init();
    if (typeof wow.sync === 'function') {
        wow.sync();
    }
};

exports.shouldUpdateScroll = () => {
    forceScrollToTop();
    return false;
};
